// Adresa stranice biznisa. Lanci sa istim imenom (npr. 7x "Apoteka Dr.Max"):
// prva radnja (najmanji id) ima /biznis/<ime>, ostale /biznis/<ime>/<id>, da
// svaka radnja ima svoju stranicu. bizDupes.json pravi gen-sitemap.cjs pri buildu.
import DUPES from "./bizDupes.json";

// Samo sopstveni ključevi: naziv lokala "constructor" ili "toString" ne sme da pogodi Object.prototype
const dupesOf = (name) => (Object.prototype.hasOwnProperty.call(DUPES, name) ? DUPES[name] : null);

export function bizPath(b) {
  const name = (b && (b.name || b.ime)) || "";
  const ids = dupesOf(name);
  const id = Number(b && b.id);
  const suffix = ids && id && id !== ids[0] ? `/${id}` : "";
  return `/biznis/${encodeURIComponent(name)}${suffix}`;
}

// Da li ime deli više radnji (tada naslov i lista dobijaju i adresu/deo grada)
export function isChainName(name) {
  return !!dupesOf(name);
}

// Po čemu se radnja lanca razlikuje: ulica iz adrese, a ako je nema, deo grada.
// Za biznis koji nije deo lanca vraća "".
export function chainPlace(b) {
  if (!b || !isChainName(b.name || b.ime)) return "";
  const street = String(b.address || b.adresa || "").split(",")[0].trim();
  return street && !/^novi sad/i.test(street) ? street : (b.deoGrada || b.deo_grada || "");
}
